<div class="inset-tile">
    <div class="chart-header">
        <h2 translate>{{header}}
        </h2>
        <h5 translate>{{subheader}}</h5>
    </div>
    <div id="graph-container">
        <canvas id="{{id}}" class="chart" width="100%"></canvas>
    </div>
    <div class="legend">
        <div *ngFor="let row of legend; let i = index" class="item">
            <i class="bullet" [style.background-color]="colors[i]"></i>{{row}}</div>
    </div>
</div>
<div class="clearfix"></div>